"use client";

import { usePermissions } from "@/hooks/usePermissions";
import { PermissionSubject, PermissionAction } from "@/utils/permissions";

interface PermissionGuardProps {
  children: React.ReactNode;
  subject: PermissionSubject | string;
  action: PermissionAction | string;
  fallback?: React.ReactNode;
}

/**
 * Component để kiểm tra quyền hạn trước khi hiển thị nội dung
 * Chỉ hiển thị children nếu user có quyền truy cập
 */
function PermissionGuard({
  children,
  subject,
  action,
  fallback = null,
}: PermissionGuardProps) {
  const { hasPermission } = usePermissions();

  // Kiểm tra quyền hạn
  const hasAccess = hasPermission(subject, action);

  // Nếu có quyền thì hiển thị children, ngược lại hiển thị fallback
  return hasAccess ? <>{children}</> : <>{fallback}</>;
}

export default PermissionGuard;
